/* bs-collection-hero — nav del carrusel de subcategorías (prev/next + counter).
   Pattern: vanilla JS, init all [data-bs-ch-subcats] al load + shopify:section:load.
   No custom element — más simple, no necesita lifecycle. */

(function () {
  'use strict';

  function getStep(track, cards) {
    if (!cards.length) return 0;
    const cardWidth = cards[0].offsetWidth;
    let gap = 12;
    const computed = window.getComputedStyle(track);
    const parsedGap = parseFloat(computed.gap || computed.columnGap);
    if (!Number.isNaN(parsedGap)) gap = parsedGap;
    return cardWidth + gap;
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function updateUi(host, refs, announce) {
    const { track, prevBtn, nextBtn, counter, cards, nav } = refs;
    if (!track) return;

    const scrollLeft = track.scrollLeft;
    const maxScroll = track.scrollWidth - track.clientWidth;
    const step = getStep(track, cards);
    const cardsVisible =
      step > 0 ? Math.max(1, Math.floor((track.clientWidth + 0.5) / step)) : 1;
    const totalPages = Math.max(1, Math.ceil(cards.length / cardsVisible));

    // Si todo cabe en 1 sola página (maxScroll <=0 o totalPages == 1) → ocultar nav.
    if (nav) {
      if (totalPages <= 1 || maxScroll <= 1) {
        nav.hidden = true;
        return;
      } else {
        nav.hidden = false;
      }
    }

    // Disabled state nav buttons
    if (prevBtn) {
      const prevDisabled = scrollLeft < 1;
      prevBtn.disabled = prevDisabled;
      prevBtn.setAttribute('aria-disabled', prevDisabled ? 'true' : 'false');
    }
    if (nextBtn) {
      const nextDisabled = scrollLeft >= maxScroll - 1;
      nextBtn.disabled = nextDisabled;
      nextBtn.setAttribute('aria-disabled', nextDisabled ? 'true' : 'false');
    }

    // Counter "page / totalPages"
    if (counter) {
      const pageWidth = cardsVisible * step;
      let page;
      if (scrollLeft >= maxScroll - 2) {
        page = totalPages;
      } else if (pageWidth > 0) {
        page = Math.round(scrollLeft / pageWidth) + 1;
      } else {
        page = 1;
      }
      const clampedPage = Math.max(1, Math.min(page, totalPages));
      counter.textContent = clampedPage + ' / ' + totalPages;

      if (announce === true) {
        counter.setAttribute('aria-live', 'polite');
      } else {
        counter.removeAttribute('aria-live');
      }
    }
  }

  function scrollByCard(track, cards, direction) {
    const step = getStep(track, cards);
    if (step <= 0) return;
    const behavior = prefersReducedMotion() ? 'auto' : 'smooth';
    const maxScroll = track.scrollWidth - track.clientWidth;
    const current = track.scrollLeft;
    let target = direction > 0 ? current + step : current - step;
    target = Math.max(0, Math.min(target, maxScroll));
    track.scrollTo({ left: target, behavior });
  }

  function init(host) {
    if (!host || host.__bsCollHeroInit) return;
    host.__bsCollHeroInit = true;

    const track = host.querySelector('[data-bs-ch-track]');
    if (!track) return;

    const cards = Array.from(track.querySelectorAll('.bs-coll-hero__subcat-card'));
    if (cards.length === 0) return;

    const prevBtn = host.querySelector('[data-direction="prev"]');
    const nextBtn = host.querySelector('[data-direction="next"]');
    const counter = host.querySelector('[data-bs-ch-current]');
    const nav = host.querySelector('[data-bs-ch-nav]');

    const refs = { track, prevBtn, nextBtn, counter, cards, nav };

    function scrollByPage(dir) {
      const step = getStep(track, cards);
      if (step <= 0) return;
      const cardsVisible = Math.max(1, Math.floor((track.clientWidth + 0.5) / step));
      const pageWidth = cardsVisible * step;
      const behavior = prefersReducedMotion() ? 'auto' : 'smooth';
      const maxScroll = track.scrollWidth - track.clientWidth;
      const target = Math.max(0, Math.min(track.scrollLeft + dir * pageWidth, maxScroll));
      track.scrollTo({ left: target, behavior });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        scrollByPage(-1);
        setTimeout(() => updateUi(host, refs, true), 350);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        scrollByPage(1);
        setTimeout(() => updateUi(host, refs, true), 350);
      });
    }

    const onScroll = () => updateUi(host, refs, false);
    const onResize = () => updateUi(host, refs, false);

    track.addEventListener('scroll', onScroll, { passive: true });

    // Recalcular en resize (cards visibles depende del viewport).
    window.addEventListener('resize', onResize, { passive: true });

    // Guardar handlers para cleanup en shopify:section:unload.
    host.__bsCollHeroCleanup = () => {
      track.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
    };

    // Inicial paint — defer al next frame para que el browser haya layouteado.
    requestAnimationFrame(() => updateUi(host, refs, false));
  }

  // ----- "Leer más" de la descripción del hero -----
  function initReadMore(scope) {
    scope.querySelectorAll('[data-bs-ch-desc-wrap]').forEach((wrap) => {
      if (wrap.__bsDescInit) return;
      wrap.__bsDescInit = true;

      const desc = wrap.querySelector('[data-bs-ch-desc]');
      const btn = wrap.querySelector('[data-bs-ch-desc-toggle]');
      const more = wrap.querySelector('[data-bs-ch-desc-more]');
      const less = wrap.querySelector('[data-bs-ch-desc-less]');
      if (!desc || !btn) return;

      // Muestra el botón solo si el texto (colapsado a 3 líneas por CSS) desborda.
      // Si ya está expandida, deja el botón visible para poder recogerla.
      function refresh() {
        if (!desc.isConnected) return;
        if (wrap.hasAttribute('data-expanded')) return;
        const overflows = desc.scrollHeight - desc.clientHeight > 2;
        btn.hidden = !overflows;
      }

      function clearPendingTe() {
        if (desc.__bsDescTe) {
          desc.removeEventListener('transitionend', desc.__bsDescTe);
          desc.__bsDescTe = null;
        }
      }

      function onToggle() {
        const expanding = !wrap.hasAttribute('data-expanded');
        btn.setAttribute('aria-expanded', expanding ? 'true' : 'false');
        if (more) more.hidden = expanding;
        if (less) less.hidden = !expanding;

        clearPendingTe();

        // Sin animación si el usuario prefiere reduced-motion.
        if (prefersReducedMotion()) {
          if (expanding) wrap.setAttribute('data-expanded', '');
          else wrap.removeAttribute('data-expanded');
          desc.style.maxHeight = '';
          return;
        }

        if (expanding) {
          // Colapsado → completo: fija el alto actual, quita el clamp CSS y anima hasta el alto real.
          desc.style.maxHeight = desc.clientHeight + 'px';
          wrap.setAttribute('data-expanded', '');
          const target = desc.scrollHeight;
          desc.offsetHeight; // reflow para que arranque desde el alto fijado
          requestAnimationFrame(function () {
            desc.style.maxHeight = target + 'px';
          });
          const te = function (e) {
            if (e.propertyName !== 'max-height') return;
            desc.removeEventListener('transitionend', te);
            desc.__bsDescTe = null;
            desc.style.maxHeight = ''; // alto natural → permite reflow al redimensionar
          };
          desc.__bsDescTe = te;
          desc.addEventListener('transitionend', te);
        } else {
          // Completo → colapsado: fija el alto actual, restaura el clamp y anima hasta 3 líneas.
          desc.style.maxHeight = desc.scrollHeight + 'px';
          desc.offsetHeight; // reflow
          wrap.removeAttribute('data-expanded');
          requestAnimationFrame(function () {
            desc.style.maxHeight = ''; // → clamp CSS (4.5em), transiciona
          });
        }
      }

      let raf = 0;
      function onResize() {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(refresh);
      }

      btn.addEventListener('click', onToggle);
      window.addEventListener('resize', onResize);
      wrap.__bsDescCleanup = () => {
        btn.removeEventListener('click', onToggle);
        window.removeEventListener('resize', onResize);
        cancelAnimationFrame(raf);
        clearPendingTe();
      };

      // El CSS de la sección carga en el body; en la carga inicial puede no estar aplicado aún
      // cuando corre initReadMore (el recorte no existiría → falso "no desborda"). Reevaluamos en
      // 'load' (styles ya aplicados) además del rAF (que cubre el re-init del customizer, donde
      // 'load' ya disparó y readyState es 'complete').
      requestAnimationFrame(refresh);
      if (document.readyState !== 'complete') {
        window.addEventListener('load', refresh, { once: true });
      }
    });
  }

  function initAll(root) {
    const scope = root || document;
    const hosts = scope.querySelectorAll('[data-bs-ch-subcats]');
    hosts.forEach(init);
    initReadMore(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Customizer: cuando Shopify recarga la section, re-init sobre el nodo afectado.
  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (!target) return;
    // Reset flag por si Shopify reusa el DOM
    target.querySelectorAll('[data-bs-ch-subcats]').forEach((host) => {
      if (typeof host.__bsCollHeroCleanup === 'function') {
        host.__bsCollHeroCleanup();
        host.__bsCollHeroCleanup = null;
      }
      host.__bsCollHeroInit = false;
    });
    target.querySelectorAll('[data-bs-ch-desc-wrap]').forEach((wrap) => {
      if (typeof wrap.__bsDescCleanup === 'function') wrap.__bsDescCleanup();
      wrap.__bsDescCleanup = null;
      wrap.__bsDescInit = false;
    });
    initAll(target);
  });

  // Customizer: cleanup al unload para no dejar listeners colgando.
  document.addEventListener('shopify:section:unload', (event) => {
    const target = event.target;
    if (!target) return;
    target.querySelectorAll('[data-bs-ch-subcats]').forEach((host) => {
      if (typeof host.__bsCollHeroCleanup === 'function') {
        host.__bsCollHeroCleanup();
        host.__bsCollHeroCleanup = null;
      }
      host.__bsCollHeroInit = false;
    });
    target.querySelectorAll('[data-bs-ch-desc-wrap]').forEach((wrap) => {
      if (typeof wrap.__bsDescCleanup === 'function') wrap.__bsDescCleanup();
      wrap.__bsDescCleanup = null;
      wrap.__bsDescInit = false;
    });
  });
})();
